import { css } from '@emotion/core';

export const loadingElementStyleOverrides = css({
  marginBottom: '16px',
});

type LoadingElementStylesType = { height: string; viewBoxHeight: string };

export const getLoadingElementStyles = ({
  height,
  theme,
  viewBoxHeight,
}: {
  height?: string;
  viewBoxHeight?: string;
  theme: AppTheme.WeasleyTheme;
}): LoadingElementStylesType => ({
  height: height ?? theme.loadingSkeleton.height,
  viewBoxHeight: viewBoxHeight ?? theme.loadingSkeleton.viewBoxHeight,
});
